function sendWebinarInfoToFormController(webinarTitle, culture) {
    $.ajax({
        url: '/Form/RespondToRecordedWebinarWatchNow',
        type: 'POST',
        data: JSON.stringify({
            WebinarInfo: {
                WebinarTitle: webinarTitle,
                Culture: culture
            }
        }),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {
            //alert(data.success);
        },
        error: function (xhr, ajaxOptions, thrownError) {
            //alert(xhr.status);
            //alert(thrownError);
        }
    });
}

function sendDownloadInfoToResourceCenterController(documentTitle,documentType,culture) {
    var host = window.location.host;
    $.ajax({
        url: 'https://' + host + '/' + culture + 'ResourceCenter/RespondToResourceCenterDownload',
        type: 'POST',
        data: JSON.stringify({
            DownloadInfo: {
                DocumentTitle: documentTitle,
                DocumentType: documentType,
                Culture: culture
            }
        }),
        contentType: 'application/json; charset=utf-8',
        success: function (data) {
            //alert(data.success);
        },
        error: function () {
            //alert("error");
        }
    });
}

function stc(trackType, trackValue, sourceUrl) {
    if (trackType == '' || trackType == '0' || trackValue == '' || trackValue == '0')
        return;

    var host = window.location.host;
    var protocol = 'https://';
    if (host.includes('localhost'))
        protocol = 'http://';

    var url = protocol + host + '/' + 'en' + '/Tracking/RespondToTracking';
    $.ajax({
        url: url,
        type: 'POST',
        dataType: 'JSON',
        data: { trackType: trackType, trackValue: trackValue, sourceUrl: sourceUrl },
        success: function (data) {
            //alert(data.success);
        },
        error: function () {
            //alert("error");
        }
    });
}